<ng-container *ngIf="products.length > 0">
  <ion-fab data-cy="cartFab" *ngIf="!isNewFlowCheckout" vertical="bottom" horizontal="end" slot="fixed" class="pointer" (click)="openShoppingCart()">
    <ion-badge color="light" class="item-quantity">{{products.length}}</ion-badge>
    <ion-fab-button color="danger">
      <ion-icon name="cart"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <div data-cy="cartFab" *ngIf="isNewFlowCheckout" class="new-cart-bar" [class.new-design-font]="isNewFlowCheckout" (click)="openShoppingCart()">
    <div class="new-cart-bar__left">
      <img class="new-cart-bar__icon" src="assets/icon/cart-bar.svg" alt="cart" />
      <span class="new-cart-bar__badge">{{ products.length }}</span>
    </div>

    <span class="new-cart-bar__label" translate>View cart</span>

    <span class="new-cart-bar__total">{{ cartTotal | multiCurrency }}</span>
  </div>
</ng-container>
